import React, { useEffect } from 'react'
import { useCourseReport } from '../../../ReportingGroup/context/CourseReportContext'
import ProgressCard from '../../../../../common/card/ProgressCard'
import Link from '../../../../../common/link/Link'
import { useUserReport } from '../../../ReportingGroup/context/UserReportContext'
import { getLastActivity } from '../../../ReportingGroup/utils'
import { useParams } from 'react-router-dom'
import { useGroupDashboardContext } from '../../../GroupDashboardContext'

const UserProfile = ({ from = 'course-report' }) => {
    const { selectedUser, selectedCourse, setCourseDetails, setUserDatum } = from === 'course-report' ?  useCourseReport() : useUserReport()
    const { selectedTeamType } = useGroupDashboardContext()
    const params = useParams()
    const teamId = params.team_id ?? 0

    const getFrom = from === 'course-report' ? selectedUser : selectedCourse

    const progressSummary = [
        {
            'title': 'completed', 
            'value': getFrom.completePercentage+"%",
            'theme': 'success',
        },
        {
            'title': 'date enrolled',
            'value': getFrom.dateEnrolled ?? '-',
        },
        {
            'title': 'avg quiz score',
            'value': '-',
        },
        {
            'title': 'date completed',
            'value': getFrom.dateCompleted ?? '-',
        }
    ]

    useEffect(() => {
        getCourseContent()
    }, [ selectedCourse ])

    useEffect(()=> {    
        getUserContent()
    }, [ selectedUser ])
    
    const getCourseContent = async () => {
        
        const {
            group_dashboard: { nonce, root }
        } = window

        const params = new URLSearchParams()
        params.append( 'course_id', selectedCourse.courseId )
        params.append( 'user_id', selectedUser.userId )
        params.append( 'team_id', teamId )
        params.append( 'team_type', selectedTeamType )

        await fetch(`${root}/course-report-snapshot?${params.toString()}`, {
            method: 'GET',
            headers: {
              'X-WP-Nonce': nonce,
              'Content-type': "application/json"
            },
            credentials: 'same-origin',
            processData: false,
            contentType: false,
        })
        .then( async ( resp ) => {
            if (!resp.ok) throw Error(resp.statusText)

            const res = await resp.json()

            setCourseDetails(res)
        })
        .catch(res => {
            console.log(res)
        })
    }

    const getUserContent = async () => {

        const {
            group_dashboard: { nonce, root }
        } = window

        const params = new URLSearchParams()
        params.append( 'user_id', selectedUser.userId )
        params.append( 'action', 'assignment')
        params.append( 'team_id', teamId )
        params.append( 'team_type', selectedTeamType )

        await fetch(`${root}/user-data-snapshot?${params.toString()}`, {
            method: 'GET',
            headers: {
              'X-WP-Nonce': nonce,
              'Content-type': "application/json"
            },
            credentials: 'same-origin',
            processData: false,
            contentType: false,
        })
        .then( async ( resp ) => {
            if (!resp.ok) throw Error(resp.statusText)

            const res = await resp.json()
            setUserDatum(res)
        })
        .catch(res => {
            console.log(res)
        })
    }

    const certificateLink = getFrom?.certificateLink ?? ''

    const lastActivity = getLastActivity( selectedUser )
    
    return (
        <div className='msync-reporting__detail__overview msync-report-user-profile'>
            <div className='msync-reporting__detail__overview__content'>
                <div className='msync-reporting__detail__overview__part msync-report-user-profile__user'>
                    <div className='msync-reporting__detail__overview__part__title'>Profile</div>
                    <div className='msync-reporting__detail__overview__part__content'>
                        <img src={selectedUser.avatarUrl} alt={selectedUser.name} className='msync-report-user-profile__user__img' />
                        <div className='msync-report-user-profile__user__details'>
                            <div className='msync-report-user-profile__user__details__fullname'>{ selectedUser.name }</div>
                            <div className='msync-report-user-profile__user__details__email'>{ selectedUser.email }</div>
                            <div className='msync-report-user-profile__user__details__last-seen'>{ lastActivity }</div>
                        </div>
                    </div>
                </div>
                <div className='msync-reporting__detail__overview__part msync-report-user-profile__progress'>
                    <div className="msync-reporting__detail__overview__part__title">Progress Summary</div>
                    <div className="msync-reporting__detail__overview__part__content">
                        { progressSummary.map((progress, key) => (
                            <ProgressCard content={progress} key={key} />
                        )) }
                    </div>
                </div>
                <div className="msync-reporting__detail__overview__part msync-report-user-profile__content">
                    <div className="msync-reporting__detail__overview__part__title">Content</div>
                    <div className="msync-reporting__detail__overview__part__content">
                        { <>
                            <ProgressCard 
                                content={{
                                    'title': 'expiration date',
                                    'value': selectedUser.dateExpiration ?? '-' 
                                }}
                            />
                                <Link 
                                    className={`msync-button msync-button--is-style-outline`} 
                                    link={certificateLink === "" ? false : certificateLink }
                                    target={'_blank'}
                                    disabled={certificateLink === "" ? true : false }
                                >
                                    Download Certificate
                                </Link>
                        </> }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserProfile
